/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { NodeRecordTypeMap } from '../../backendModels/records.model';
import { InputState } from '../../backendModels/general.model';
import { SingleSelectFieldValueTyped } from '../generic';

export enum BloodGlucoseAdditionKeys {
  bzhigh = 'BZ_HIGH',
  bzlow = 'BZ_LOW',
}

const bloodGlucoseAdditionLabels: Record<BloodGlucoseAdditionKeys, string> = {
  [BloodGlucoseAdditionKeys.bzhigh]: 'HIGH',
  [BloodGlucoseAdditionKeys.bzlow]: 'LOW',
};

export const BLUTZUCKER_ERWEITERT_ELEMENT_KEY = 'blutzuckerErweitert';

export type BloodGlucoseAdditionRecord = NodeRecordTypeMap['generic'] &
  (
    | {
        readonly elementKey: typeof BLUTZUCKER_ERWEITERT_ELEMENT_KEY;
        readonly inputState: InputState.ENTERED;
        readonly values: {
          blutzuckerLowHigh?: SingleSelectFieldValueTyped<BloodGlucoseAdditionKeys>;
        };
      }
    | {
        readonly inputState: InputState.UNKNOWN;
        readonly values: null;
      }
  );

export function getBloodGlucoseAdditionTupel(key: BloodGlucoseAdditionKeys): [BloodGlucoseAdditionKeys, string] {
  return [key, bloodGlucoseAdditionLabels[key]];
}
